import { Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

const api = {
  protocol: environment.api.protocol ?? location.protocol,
  hostname: environment.api.hostname ?? location.hostname,
  port: environment.api.port ?? location.port,
};

/**
 * Defines the application's routing configuration.
 *
 * This array contains route objects for the application, each specifying a path
 * and associated route handlers or redirections.
 *
 * Properties:
 * - path: A string representing the path for the route. Supports static paths and wildcards.
 * - loadChildren: A function used for lazy loading child routes. It dynamically imports
 *   the module containing the routes and resolves to the module's route array.
 * - data: An optional property used to pass extra custom data (e.g., configuration, API endpoint, etc.)
 *   associated with the route.
 * - redirectTo: Specifies a path to redirect when a route matches the wildcard or specific conditions.
 *
 * Specific Routes:
 * 1. 'base': Loads additional routes from ./page/base-page/routes module. The `data` property can
 *    include API-related information.
 * 2. '**': Acts as a wildcard route and redirects to the 'base' path.
 */
export const routes: Routes = [
  {
    path: 'base',
    loadChildren: () => import('./page/base-page/routes').then((m) => m.routes),
    data: api,
  },
  {
    path: '**',
    redirectTo: 'base',
  },
];
